import type { CvContent } from './types'

export const es: CvContent = {
  tagline: 'Performer · Bailarina · Cantante · Profesora de danza',
  intro:
    'Estudiante de BA Danza / BA Pedagogía de la danza en el Lucia Marthas Institute for Performing Arts. Experiencia escénica en el Ziggo Dome, Ahoy y AFAS Live, y dance captain de la presentación anual del LMIPA.',
  about:
    'Soy una performer entusiasta y flexible con un gran sentido de la responsabilidad. Soy constante, fiable y siempre puntual. Trabajo de forma organizada, mantengo mis tareas en orden y soy una compañera de equipo que se adapta con rapidez cuando hace falta. Además de mi trabajo sobre el escenario, disfruto mucho enseñando y transmitiendo mi pasión por el musical y las artes escénicas. Con mi energía positiva y mi dedicación contribuyo a una producción fluida y exitosa.',
  features: [
    { label: 'Color de pelo', value: 'Rubio' },
    { label: 'Ojos', value: 'Azules' },
    { label: 'Altura', value: '1,70 m' },
    { label: 'Fecha de nacimiento', value: '27/03/2005' },
  ],
  skills: [
    {
      heading: 'Canto',
      lines: ['Tipo de voz: soprano', 'Rango vocal: E3 a C6', 'Formación en:'],
      items: ['Jazz', 'Musical', 'Pop', 'Clásico', 'Ensemble y polifonía'],
    },
    {
      heading: 'Danza',
      lines: ['Formación en:'],
      items: [
        'Ballet',
        'Jazz',
        'Horton',
        'Moderno',
        'Diversos estilos latinos y porteos',
        'Teatro musical',
        'Commercial',
        'Claqué',
      ],
    },
    {
      heading: 'Interpretación',
      lines: [],
      items: [
        'Improvisación',
        'Escenas de grupo',
        'Monólogos',
        'Duólogos',
        'Interpretación en teatro y ante cámara',
      ],
    },
  ],
  experience: [
    {
      title: 'Presentación anual LMIPA',
      period: 'Jul. 2014 – actualidad',
      description:
        'En la presentación anual he sido dance captain, responsable de varias piezas. Además he creado coreografías para los grupos más jóvenes, aplicando mi creatividad y mi experiencia como profesora de danza.',
    },
    { title: 'Christmas Show, Ziggo Dome', period: 'Dic. 2016' },
    { title: 'Kinderen voor Kinderen 40 años, Ahoy', period: '2018' },
    { title: 'Lang Leve de Muziek Show AVROTROS', period: '2018 – 2019' },
    { title: 'Katja en Babbette Discobal, AFAS Live', period: 'Nov. 2025' },
    {
      title: 'Workshops',
      period: '2023 – actualidad',
      bullets: [
        'Talleres/clases con Malou Linders, Denden Karadeniz, Sergio Reis, Jordy Sparidaens, Anneke Ghysens y Laurent Flamment',
        'Talleres/clases con Caroline Dijkhuizen, Andy Señor JR, Mary-Ann Lamb, Valerie Pettifort y Michiel Varga',
      ],
    },
    {
      title: 'Profesora de danza, Lucia Marthas Institute for Performing Arts',
      period: 'Sept. 2023 – actualidad',
    },
  ],
  education: [
    {
      period: '2023',
      school: 'Gerrit van der Veen College',
      detail: 'VWO / clase DAMU LMIPA',
    },
    {
      period: 'Sept. 2023 – jul. 2027',
      school: 'Lucia Marthas Institute for Performing Arts',
      detail: 'BA Danza / BA Pedagogía de la danza',
    },
  ],
}
